export {
  transitionDuration,
  transitionEasing,
  transitionString,
} from '@catch/services';
